<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="unidades"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer />
          <v-btn
            v-if="perms.includes('un_medida.criar_unidade')"
            depressed
            color="accent"
            :to="{ name: 'unidade-medida-formulario' }"
          >
            <v-icon class="mdi mdi-beaker-plus mr-2" />Novo Cadastro
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          v-if="perms.includes('un_medida.editar_unidade')"
          icon
          small
          text
          @click="editar(item.id)"
        >
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          v-if="perms.includes('un_medida.excluir_unidade')"
          titulo="Deletar Unidade de Medida"
          texto="Confirma a exclusão?"
          @confirmar="deletar(item.id)"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import DialogConfirm from "../components/DialogConfirm";
export default {
  components: { DialogConfirm },
  data() {
    return {
      headers: [
        { text: "Código", value: "codigo" },
        { text: "Descrição", value: "descricao" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      loading: false,
      dialogConfirm: false,
    };
  },
  computed: {
    unidades() {
      return this.$store.state.unidadeMedida.unidadeMedida;
    },
    perms() {
      return this.$store.state.usuarios.usuarioAtivo.permissoes;
    },
  },
  methods: {
    async listar() {
      this.loading = true;
      try {
        await this.$store.dispatch("unidadeMedida/listar");
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a lista de unidades de medida",
        });
      }
      this.loading = false;
    },
    async deletar(id) {
      this.loading = true;
      await this.$store.dispatch("unidadeMedida/deletar", { id });

      this.listar();
    },
    editar(id) {
      this.$router.replace({
        name: "unidade-medida-formulario-editar",
        params: { id },
      });
    },
  },

  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de unidades de medida",
    });
    this.listar();
  },
};
</script>
